/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarymoments1Inputs */

const en_summarymoments1 = /** @type {(inputs: Summarymoments1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moments`)
};

const de_summarymoments1 = /** @type {(inputs: Summarymoments1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momente`)
};

/**
* | output |
* | --- |
* | "Moments" |
*
* @param {Summarymoments1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarymoments1 = /** @type {((inputs?: Summarymoments1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarymoments1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarymoments1(inputs)
	return de_summarymoments1(inputs)
});
export { summarymoments1 as "summaryMoments" }